import requestJWT from "utils/requestJWT";

const createApi = async (data) => {
    return await requestJWT.post(`/comment/create`, data);
};

const updateApi = async (id, data) => {
    return await requestJWT.put(`/comment/${id}/update`, data);
};

const removeApi = async (id) => {
    return await requestJWT.delete(`/comment/${id}/remove`);
};


const getAllApi = async (id, page, sort) => {
    return await requestJWT.get(`/comment/${id}/get-by-tour?page=${page}&item=5&sort=${sort}`);
};

export {
    createApi,
    getAllApi,
    updateApi,
    removeApi
};
